import React, { useState } from 'react';
import { Box, Button, CircularProgress, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import OnboardingContainer from '../../Component/OnboardingContainer';
import { ScreenBackV2WithTitle } from '../../../Components/ScreenBackV2';
import {
  GetMeAction,
  onboardFirmAction,
  refreshTokenAction,
} from '../../auth/action';
import { useDispatch, useSelector } from 'react-redux';
import OnboardingSummaryCard from '../../Component/onboardingSummaryCard';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getSecondaryPermissionsAction } from '../../../../screen/auth/action';

const FetchFirmDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { addedFirms, addingFirmFromProfile } = useSelector(
    (state) => state.firmOnbaordingReducer,
  );

  const [loading, setLoading] = useState(false);

  const onAddRole = (item) => {
    dispatch({
      type: 'SET_EDITING_INDUSTRY',
      data: item,
    });

    navigate('/IndustrySelect');
  };

  const onEditFirm = (item) => {
    navigate('/FirmOnboarding', { state: { edit_firm_details: item } });
  };

  const onAddFirm = () => {
    dispatch({
      type: 'PARTIAL_RESET_FIRM_ONBOARDING_REDUCER',
    });

    navigate('/FetchFirmDetail');
  };

  const onFinish = async () => {
    const payload = addedFirms.map((item) => ({
      company_name: item.firm_name,
      company_gstin: item.document_type === 'GSTIN' ? item.document_id : null,
      company_address: {
        address_line_1: item.address_line_1,
        address_line_2: item.address_line_2,
        address_line_3: item.address_line_3,
      },
      pincode: item.firm_pincode,
      location_id: item?.location_id,
      pancard_no: item.document_type !== 'GSTIN' ? item.document_id : null,
      district_id: item.district_id,
      pancard_no: item.pancard_no,
      role_details: Object.keys(item.roles).map((role) => {
        const tempRole = item.roles[role];
        return {
          manufacturer_id: tempRole.manufacturer_id,
          region_role_id: tempRole.region_role_id,
          pricing_geography_id: tempRole.pricing_geography_id,
        };
      }),
    }));

    setLoading(true);

    const { error, message } = await onboardFirmAction(payload);

    setLoading(false);

    if (!error) {
      toast.success(message);

      const { error: userError, data: loggedInUser } = await GetMeAction();
      const { error: tokenError, data: tokenData } = await refreshTokenAction();
      const { data: secPermissionData } = await getSecondaryPermissionsAction();

      if (!userError && loggedInUser) {
        if (addingFirmFromProfile) {
          if (tokenData) localStorage.setItem('token', tokenData);
          dispatch({ type: 'SET_USER', data: loggedInUser });
          dispatch({
            type: 'SET_SECONDARY_PERMISSION',
            data: secPermissionData,
          });
          dispatch({
            type: 'SET_SECONDARY_PERMISSION_ROLES',
            data: secPermissionData.map((item) => item.role_name),
          });
          dispatch({
            type: 'RESET_FIRM_ONBOARDING_REDUCER',
          });
          navigate('/my-account/firm-details');
        } else {
          dispatch({
            type: 'RESET_FIRM_ONBOARDING_REDUCER',
          });
          if (tokenData) localStorage.setItem('token', tokenData);

          dispatch({ type: 'SET_USER', data: loggedInUser });
          dispatch({
            type: 'SET_SECONDARY_PERMISSION',
            data: secPermissionData,
          });

          dispatch({
            type: 'SET_SECONDARY_PERMISSION_ROLES',
            data: secPermissionData.map((item) => item.role_name),
          });

          navigate('/');
        }
      }
    } else {
      return toast.error(message);
    }
  };

  return (
    <OnboardingContainer>
      <ScreenBackV2WithTitle title={'Firm Onboarding Summary'} />
      <Box
        sx={
          {
            // height: window.innerHeight * 0.6,
            // overflowY: 'auto',
            // alignItems: 'center',
          }
        }
      >
        {addedFirms.map((item, index) => (
          <OnboardingSummaryCard
            key={item.document_id}
            data={item}
            onAddRole={() => onAddRole(item)}
            onEditFirm={() => onEditFirm(item)}
          />
        ))}

        <Stack
          spacing={2}
          direction={'row'}
          alignItems={'center'}
          alignContent={'center'}
        >
          <Button
            variant='outlined'
            color='primary'
            sx={{ width: '100%' }}
            onClick={onAddFirm}
          >
            {addedFirms.length > 0 ? 'Add Another Firm' : 'Add Firm'}
          </Button>
          <Button
            variant='contained'
            color='primary'
            sx={{ width: '100%' }}
            onClick={onFinish}
            startIcon={
              loading && (
                <CircularProgress
                  sx={{ color: 'white' }}
                  size={20}
                />
              )
            }
          >
            {loading ? 'Loading...' : 'Submit'}
          </Button>
        </Stack>
      </Box>
    </OnboardingContainer>
  );
};

export default FetchFirmDetail;
